import Typography from "@mui/joy/Typography";
import { memo } from "react";
import { Stack } from "@mui/joy";
import { Status } from "./TaskItemTemplate";
import dayjs from "dayjs";
import useOpenThoughtRecord from "hooks/useOpenThoughtRecord";
import useOpenMeditationRecord from "hooks/useOpenMeditationRecord";
import { theme } from "styles/theme";

function ToolItem({
  thoughtRecordKey,
  meditationRecordKey,
  title,
  date,
  isOpen,
  isDone,
}: {
  thoughtRecordKey?: string;
  meditationRecordKey?: string;
  title: string;
  date: string;
  isOpen: boolean;
  isDone: boolean;
}) {
  const openThoughtRecord = useOpenThoughtRecord(`${thoughtRecordKey}`);
  const openMeditationRecord = useOpenMeditationRecord(
    `${meditationRecordKey}`
  );

  return (
    <Stack
      direction="row"
      alignItems={"center"}
      sx={{
        cursor: "pointer",
        px: "12px",
        py: "8px",
        borderRadius: "12px",
        "@media (min-width: 1024px)": {
          "&:hover": {
            backgroundColor: theme.vars.palette.Surface.Backward,
          },
        },
        "@media (max-width: 1024px)": {
          "&:hover": {
            backgroundColor: theme.vars.palette.Surface.Forward,
          },
        },
        "&:active": {
          backgroundImage: `linear-gradient(${theme.vars.palette.hoverLight}, ${theme.vars.palette.hoverLight})`,
        },
        "&:focus": {
          backgroundColor: theme.vars.palette.Surface.Forward,
        },
      }}
      onClick={() => {
        if (thoughtRecordKey) {
          openThoughtRecord();
        } else if (meditationRecordKey) {
          openMeditationRecord();
        }
      }}
    >
      <Stack
        direction="row"
        alignItems={"center"}
        spacing={"8px"}
        sx={{ flex: 1 }}
      >
        <Status isOpen={isOpen} isDone={isDone} />

        <Typography
          sx={{
            flex: 1,
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: "1",
            WebkitBoxOrient: "vertical",
          }}
          fontWeight={500}
        >
          <Typography
            variant={"Body"}
            sx={{
              fontWeight: 500,
              flex: 1,
              color: theme.vars.palette.Content.Weak,
              mr: "8px",
              px: 0
            }}
          >
            {dayjs(date).format("M/D")}
          </Typography>

          <Typography
            variant={"Body"}
            sx={{ fontWeight: 500, color: theme.vars.palette.Content.Strong, px: 0 }}
          >
            {title}
          </Typography>
        </Typography>
      </Stack>
    </Stack>
  );
}

export default memo(ToolItem);